import * as React from 'react';
import { useDropzone } from 'react-dropzone';
export const useBlobContainerUpload = _ref => {
  let {
    blacklist,
    fileValidator,
    maxFilesNumber,
    filesNumber,
    accept,
    onComplete,
    onError,
    onProgress
  } = _ref;
  const [validating, setValidating] = React.useState(false);
  //types are incorrect for this third party lib hence the any
  const blacklister = async event => {
    setValidating(true);
    const files = [];
    const fileList = event.dataTransfer ? event.dataTransfer.files : event.target.files;
    for (var i = 0; i < fileList.length; i++) {
      const file = fileList[i];
      const blacklisted = blacklist === null || blacklist === void 0 ? void 0 : blacklist.find(item => item.fileName === file.name);
      if (blacklisted) {
        Object.defineProperty(file, 'blacklisted', {
          value: blacklisted.reason
        });
      } else {
        if (fileValidator) {
          const valid = await fileValidator(file);
          if (!valid.valid) {
            Object.defineProperty(file, 'blacklisted', {
              value: valid.errors
            });
          }
        }
      }
      const maxFilesCountExceeded = maxFilesNumber && filesNumber !== undefined && files.length + filesNumber >= maxFilesNumber;
      if (maxFilesCountExceeded) {
        break;
      }
      files.push(file);
    }
    setValidating(false);
    return files;
  };
  const {
    getRootProps,
    getInputProps,
    acceptedFiles
  } = useDropzone({
    getFilesFromEvent: event => blacklister(event),
    accept: accept
  });
  const [completed, setCompleted] = React.useState([]);
  const [failed, setFailed] = React.useState([]);
  const [succeeded, setSucceeded] = React.useState([]);
  React.useEffect(() => {
    if (failed.length + succeeded.length === acceptedFiles.length && completed.length !== 0) {
      if (onComplete) {
        onComplete(succeeded, failed);
      }
    }
    if (onProgress) {
      onProgress(acceptedFiles.length, completed.length);
    }
  }, [failed, succeeded, completed, acceptedFiles]);
  React.useEffect(() => {
    if (onError && failed.length !== 0) {
      onError(failed);
    }
  }, [failed]);
  return {
    completed,
    failed,
    succeeded,
    acceptedFiles,
    validating,
    getRootProps,
    getInputProps,
    setCompleted,
    setFailed,
    setSucceeded
  };
};